import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { setToken } from "@/utils";
import { useAppDispatch } from "@/utils/redux";
import { DashboardRoutes } from "@/router/constant";
import { useAtom } from "jotai";
import { dashboardPreferencesAtom } from "@/core/state";
import { selectAtom } from "jotai/utils";

const urlForLoginRedirectAtom = selectAtom(dashboardPreferencesAtom, (val) => val.urlForLoginRedirect);

const OAuthCallbackPage: React.FC = () => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const [settled, setSettled] = useState<boolean>(false);
  const [urlForLoginRedirect] = useAtom(urlForLoginRedirectAtom);

  useEffect(() => {
    const token = location.hash.split("access_token=")[1]?.split("&")[0];

    if (token) {
      setToken.forAll(dispatch, token);
    }
    setSettled(true);
  }, [dispatch, location.hash]);

  if (settled) {
    return <Navigate to={urlForLoginRedirect || DashboardRoutes.home.root.url} />;
  }
  return null;
};

export default OAuthCallbackPage;
